import "tippy.js/dist/tippy.css";
import Tippy from "@tippyjs/react";

export type TooltipProps = React.ComponentProps<typeof Tippy>;

export const Tooltip = Tippy;
